// src/components/UpcomingEventsWidget.js
import React, { useState, useEffect } from 'react';

const UpcomingEventsWidget = ({ onViewAllClick }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_KEY = 'AIzaSyCh8gFKSzTrKu4IEFYg4G-y6A9B2qGg7VQ';

  const CALENDARS = [
    { id: 'bestuurpolderzicht@gmail.com', label: 'Bestuur' },
    { id: '5aaibmgnah685p86io04932curmdsg29@import.calendar.google.com', label: 'Groot Onderhoud' },
    { id: 'e0vruh7sid1pmqddpbpaqdjn8j1t44fl@import.calendar.google.com', label: 'Onderhoud' },
  ];
  const MAX_DISPLAY = 6;

  useEffect(() => {
    const fetchAllEvents = async () => {
      const now = new Date().toISOString();
      let allEvents = [];

      try {
        for (const calendar of CALENDARS) {
          const response = await fetch(
            `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(calendar.id)}/events?key=${API_KEY}&timeMin=${now}&singleEvents=true&orderBy=startTime`
          );
          const data = await response.json();
          if (data.items) {
            const eventsWithSource = data.items.map(item => ({
              ...item,
              calendarLabel: calendar.label
            }));
            allEvents = [...allEvents, ...eventsWithSource];
          }
        }
        allEvents.sort((a, b) => new Date(a.start.dateTime || a.start.date) - new Date(b.start.dateTime || b.start.date));
        setEvents(allEvents);
      } catch (error) {
        console.error('Error fetching events:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllEvents();
  }, []);

  const formatEvent = (event) => (
    <li key={event.id} style={{ marginBottom: '8px' }}>
      <strong>{new Date(event.start.dateTime || event.start.date).toLocaleDateString('nl-NL')}</strong>
      {event.start.dateTime ? ` ${new Date(event.start.dateTime).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}` : ''}
        : {event.summary}
      <div style={{ fontSize: '0.8em', color: 'gray' }}>({event.calendarLabel})</div>
    </li>
  );

  return (
    <div className="card">
      <h3>Komende afspraken</h3>
      {loading ? (
        <p>Laden...</p>
      ) : events.length > 0 ? (
        <>
          <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
            {events.slice(0, MAX_DISPLAY).map(event => formatEvent(event))}
          </ul>
          {events.length > MAX_DISPLAY && (
            <button
              onClick={() => onViewAllClick(events)}
              className="custom-button"
              style={{ marginTop: '10px' }}
            >
              Bekijk alle afspraken
            </button>
          )}
        </>
      ) : (
        <p>Geen komende afspraken</p>
      )}
    </div>
  );
};

export default UpcomingEventsWidget;